import createAxiosInstance from '../../../api';
import { useAlert } from '../../../components/Notification';
import { useDispatch } from 'react-redux';
import {
  setCustomerListListAction,
  setCustomerDetailsAction,
  setCustomerUnitDetailsAction,
  setCustomerFilterAction,
} from '../../../stores/actionTypes/customerManagementAction';
import { useNavigate } from 'react-router-dom';

export function useHook() {
  const axiosInstance = createAxiosInstance();
  const showAlert = useAlert();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const fetchCustomerList = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/customerList', payload)
      .then((response) => {
        dispatch(setCustomerListListAction(response?.data?.data));
        data = response.data;
      })
      .catch(() => {
        dispatch(setCustomerListListAction([]));
        showAlert('Failed get Customer List', 'warning');
      });
    return data;
  };

  const fetchDealerCustomerList = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/dealers/customerList', payload)
      .then((response) => {
        dispatch(setCustomerListListAction(response?.data?.data));
        data = response.data;
      })
      .catch(() => {
        dispatch(setCustomerListListAction([]));
        showAlert('Failed get Customer List', 'warning');
      });
    return data;
  };

  const fetchCustomerDetails = async (payload) => {
    await axiosInstance
      .post('/customerDetails', payload)
      .then((response) => {
        dispatch(setCustomerDetailsAction(response?.data?.data));
      })
      .catch(() => {
        showAlert('Failed get Customer details', 'warning');
        dispatch(setCustomerDetailsAction({}));
        navigate('/customermanagement');
      });
  };

  const fetchDealerCustomerDetails = async (payload) => {
    await axiosInstance
      .post('/dealers/customerDetails', payload)
      .then((response) => {
        dispatch(setCustomerDetailsAction(response?.data?.data));
      })
      .catch(() => {
        showAlert('Failed get Customer details', 'warning');
        dispatch(setCustomerDetailsAction({}));
        navigate('/customermanagement');
      });
  };

  const fetchCustomerUnitDetails = async (payload) => {
    await axiosInstance
      .post('/customerUnitDetails', payload)
      .then((response) => {
        dispatch(setCustomerUnitDetailsAction(response?.data?.data));
      })
      .catch(() => {
        showAlert('Failed get Customer details', 'warning');
        dispatch(setCustomerUnitDetailsAction({}));
        navigate('/customermanagement');
      });
  };

  const fetchDealerCustomerUnitDetails = async (payload) => {
    await axiosInstance
      .post('/dealers/getEquipmentDetails', payload)
      .then((response) => {
        dispatch(setCustomerUnitDetailsAction(response?.data?.data));
      })
      .catch(() => {
        showAlert('Failed get Customer details', 'warning');
        dispatch(setCustomerUnitDetailsAction({}));
        navigate('/customermanagement');
      });
  };

  const fetchEquipmentDeatils = async (payload) => {
    await axiosInstance
      .post('/customerUnitDetails', payload)
      .then((response) => {
        dispatch(setCustomerUnitDetailsAction(response?.data?.data));
      })
      .catch(() => {
        showAlert('Failed get equipment details', 'warning');
        dispatch(setCustomerUnitDetailsAction({}));
        // navigate('/customermanagement');
      });
  };

  const fetchDealerEquipmentDeatils = async (payload) => {
    await axiosInstance
      .post('/dealers/getEquipmentDetails', payload)
      .then((response) => {
        dispatch(setCustomerUnitDetailsAction(response?.data?.data));
      })
      .catch(() => {
        showAlert('Failed get equipment details', 'warning');
        dispatch(setCustomerUnitDetailsAction({}));
        // navigate('/customermanagement');
      });
  };

  const updateSubscription = async (payload) => {
    await axiosInstance
      .post('/updateSubscription', payload)
      .then(() => {
        showAlert('Subscription updated successfully', 'success');
      })
      .catch(() => {
        showAlert('Failed to subscription updated', 'warning');
      });
  };

  const updateDealerSubscription = async (payload) => {
    await axiosInstance
      .post('/dealers/updateSubscription', payload)
      .then(() => {
        showAlert('Subscription updated successfully', 'success');
      })
      .catch(() => {
        showAlert('Failed to subscription updated', 'warning');
      });
  };

  const fetchReadTimeSerieseParameter = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/readTimeSeriesParameter', payload)
      .then((response) => {
        // dispatch(setEquipmentFilterInfoAction(response?.data?.data));
        data = response.data;
      })
      .catch((error) => {
        // dispatch(setEquipmentFilterInfoAction([]));
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
    return data;
  };

  const fetchDealerReadTimeSerieseParameter = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/dealers/readTimeSeriesParameter', payload)
      .then((response) => {
        // dispatch(setEquipmentFilterInfoAction(response?.data?.data));
        data = response.data;
      })
      .catch((error) => {
        // dispatch(setEquipmentFilterInfoAction([]));
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
    return data;
  };

  const fetchReadUnitParameter = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/readUnitParameter', payload)
      .then((response) => {
        data = response.data?.data;
      })
      .catch((error) => {
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
    return data;
  };

  const fetchDealerReadUnitParameter = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/dealers/readUnitParameter', payload)
      .then((response) => {
        data = response.data?.data;
      })
      .catch((error) => {
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
    return data;
  };
  const fetchWriteUnitParameterValue = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/writeUnitParameterValue', payload)
      .then((response) => {
        data = response.data?.data;
      })
      .catch((error) => {
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
    return data;
  };

  const fetchDealerWriteUnitParameterValue = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/dealers/writeUnitParameterValue', payload)
      .then((response) => {
        data = response.data?.data;
      })
      .catch((error) => {
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
    return data;
  };

  const updateWriteParameter = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/updateWriteParameter', payload)
      .then((response) => {
        showAlert('Write Parameter updated successfully', 'success');
        data = response.data;
      })
      .catch((error) => {
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
    return data;
  };

  const updateDealerWriteParameter = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/dealers/updateWriteParameter', payload)
      .then((response) => {
        showAlert('Write Parameter updated successfully', 'success');
        data = response.data;
      })
      .catch((error) => {
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
    return data;
  };
  const fetchAlertList = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/getAlerts', payload)
      .then((response) => {
        data = response.data?.data;
      })
      .catch((error) => {
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
    return data;
  };

  const fetchDealerAlertList = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/dealers/getAlerts', payload)
      .then((response) => {
        data = response.data?.data;
      })
      .catch((error) => {
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
    return data;
  };

  const updateDeviceName = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/updateDeviceName', payload)
      .then((response) => {
        showAlert('Device Name updated successfully', 'success');
        data = response;
      })
      .catch((error) => {
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
    return data;
  };

  const fetchGetCustomerFilter = async () => {
    await axiosInstance
      .get('/customerFilters')
      .then((response) => {
        dispatch(setCustomerFilterAction(response?.data?.data));
      })
      .catch(() => {
        dispatch(setCustomerFilterAction({}));
        showAlert('Failed get  Customer Filter', 'warning');
      });
  };

  const fetchGetDealerCustomerFilter = async () => {
    await axiosInstance
      .get('/dealers/customerFilters')
      .then((response) => {
        dispatch(setCustomerFilterAction(response?.data?.data));
      })
      .catch(() => {
        dispatch(setCustomerFilterAction({}));
        showAlert('Failed get  Customer Filter', 'warning');
      });
  };
  return {
    fetchCustomerList,
    fetchDealerCustomerList,
    fetchCustomerDetails,
    fetchDealerCustomerDetails,
    fetchCustomerUnitDetails,
    fetchDealerCustomerUnitDetails,
    updateSubscription,
    updateDealerSubscription,
    fetchReadTimeSerieseParameter,
    fetchDealerReadTimeSerieseParameter,
    fetchReadUnitParameter,
    fetchDealerReadUnitParameter,
    fetchWriteUnitParameterValue,
    fetchDealerWriteUnitParameterValue,
    updateWriteParameter,
    updateDealerWriteParameter,
    fetchAlertList,
    fetchDealerAlertList,
    updateDeviceName,
    fetchEquipmentDeatils,
    fetchDealerEquipmentDeatils,
    fetchGetCustomerFilter,
    fetchGetDealerCustomerFilter,
  };
}
